import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import theme from '../../style/theme';
import ThemeButton from '../ThemeButton';

const ConfirmationButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const ConfirmationText = styled.div`
  margin-bottom: 3rem;
`;

const Text = styled.p`
  margin-bottom: 1rem;
`;

const Title = styled.div`
  padding: 5px 0;
  margin-right: 10.5px;
  font-weight: bold;
  font-size: 16px;
  line-height: 36px;
  color: ${(props) => props.theme.colors.black};
`;

interface Props {
  show: boolean;
  text: string;
  text2?: string;
  showTitle?: boolean;
  titleText?: string;
  onResponse: (r: boolean, i?: number) => void;
  hideCancelButton?: boolean;
  fillSpace?: boolean;
  cancelButtonTextKey?: string;
  cancelButtonColor?: string;
  yesButtonTextKey?: string;
  yesButtonColor?: string;
}

const ConfirmationModal = ({
  show,
  text,
  text2,
  showTitle = false,
  titleText = '',
  onResponse,
  hideCancelButton = false,
  fillSpace = false,
  cancelButtonColor = theme.colors.radicalRed,
  cancelButtonTextKey = 'confirmation_no',
  yesButtonColor = theme.colors.lightSeaGreen,
  yesButtonTextKey = 'confirmation_yes',
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} backdrop="static">
      <Modal.Body data-test-id="confirmation-modal">
        {showTitle && <Title>{titleText}</Title>}
        <ConfirmationText>
          <Text>{text}</Text>
          {text2 && <Text>{text2}</Text>}
        </ConfirmationText>
        <ConfirmationButtonBox>
          {!hideCancelButton && (
            <ThemeButton
              $color={cancelButtonColor}
              $fillSpace={fillSpace}
              onClick={() => onResponse(false)}
              data-test-id="confirmation-cancel-btn"
            >
              {t(cancelButtonTextKey)}
            </ThemeButton>
          )}
          <ThemeButton
            $color={yesButtonColor}
            $fillSpace={fillSpace}
            onClick={() => onResponse(true)}
            data-test-id="confirmation-yes-btn"
          >
            {t(yesButtonTextKey)}
          </ThemeButton>
        </ConfirmationButtonBox>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
